const commonEN = {
	email: 'Email',
	password: 'Password',
	newPassword: 'New Password',
	confirmNewPassword: 'Confirm New Password',
	menu: 'Menu'
};

export default commonEN;
